@if (isLoading) {
  <div id="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}

<div class="container">
  <custom-table
    [tableData]="apiIntegrationData"
    [tableColumns]="tableColumns"
    [tableActions]="tableActions"
    [filterAttributes]="filterAttributes"
    [dateRangeDetails]="dateRangeDetails"
    [onlyDefaultColumns]="true"
    [handleToggleInParent]="true"
    isFilterPresent="true"
    isdatePicker="true"
    (tableActionEmitter)="tableAction($event)"
    (rowAction)="rowAction($event)"
    (toogleEmitter)="updateStatus($event)">
  </custom-table>
</div>
